import React, {useEffect} from 'react';
import {connect} from 'react-redux';
//Material-UI
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/styles';
//GraphQL
import {useLazyQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
//DS
import {GeneralInformacion, Producto, Herramientas, ServiciosPostventa} from './componentes';
import {validacion} from 'lib.common';
import {loadingModal, openMsg} from 'redux-app';
const {esVarNullUndef} = validacion;

const useStyles = makeStyles(theme => ({
   root: {
      padding: theme.spacing(4)
   }
}));

const queryRecuperarDS = gql`
   query Cliente($cliente: String) {
      clienteProductosFiltro(cliente: $cliente) {
         producto {
            codigo
            denominacion
            observacion
            links {
               codigoLink
               denominacion
               descripcion
               url
            }
         }
         fechaHora
      }
   }
`;
function Home({usuario, openWaitModal, openMsgModal}) {
   const classes = useStyles();
   /*
  Inicializar estados
  */
   let [recuperar, {called, loading, data, error}] = useLazyQuery(queryRecuperarDS);
   useEffect(() => {
      recuperar({variables: {cliente: usuario.codigo}});
   }, [usuario]);

   //Inicializar con los datos del usuario actual
   useEffect(() => {
      openWaitModal(loading);
   }, [loading]);

   useEffect(() => {
      if (error) {
         openMsgModal(error.toString());
      }
   }, [error]);
   if (called && loading)
      return (
         <div id="loadingReporteCaso" style={{width: '100%', height: '100%'}}>
            {/* <LoadingModal open={loading} noFullScreen containerId="MainContainer" />*/}
         </div>
      );
   if (!called && !loading) {
      return null;
   }
   return (
      <div className={classes.root}>
         <Grid container spacing={3}>
            <Grid item xs={12}>
               <Typography align="center" variant="h3" gutterBottom>
                  Bienvenido(a)
               </Typography>
            </Grid>
            <Grid item xs={3}>
               {!esVarNullUndef(usuario) && <GeneralInformacion data={usuario} />}
            </Grid>
            <Grid item xs={9}>
               {!esVarNullUndef(usuario) && <ServiciosPostventa />}
            </Grid>
            {!esVarNullUndef(data) && <Producto data={data['clienteProductosFiltro']} />}
         </Grid>
         <Grid container spacing={3}>
            <Grid item xs={3}>
               {!esVarNullUndef(usuario) && <Herramientas />}
            </Grid>
         </Grid>
      </div>
   );
}

function mapStateToProps(state) {
   return {
      usuario: state.auth.usuario
   };
}

function mapDispatchToProps(dispatch) {
   return {
      openWaitModal: loading => dispatch(loadingModal(loading)),
      openMsgModal: msg => dispatch(openMsg(msg))
   };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
